import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import TripTypes from './pages/TripTypes';
import HajjUmrah from './pages/HajjUmrah';
import SoutheastAsia from './pages/SoutheastAsia';
import LatinAmerica from './pages/LatinAmerica';
import AfricaSafari from './pages/AfricaSafari';
import BusinessTravel from './pages/BusinessTravel';
import FamilyTravel from './pages/FamilyTravel';
import About from './pages/About';
import Resources from './pages/Resources';
import TravelEssentials from './pages/TravelEssentials';
import Admin from './pages/Admin';
import ByCity from './pages/ByCity';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import TravelVaccinesCanadaGuide from './pages/articles/TravelVaccinesCanadaGuide';
import VaccinesNeededIndiaTravel from './pages/articles/VaccinesNeededIndiaTravel';
import YellowFeverVaccineRequirements from './pages/articles/YellowFeverVaccineRequirements';
import PartnerLanding from './pages/PartnerLanding';
import PartnerDashboard from './pages/PartnerDashboard';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trip-types" element={<TripTypes />} />
          <Route path="/trip-types/hajj-umrah" element={<HajjUmrah />} />
          <Route path="/trip-types/southeast-asia" element={<SoutheastAsia />} />
          <Route path="/trip-types/latin-america" element={<LatinAmerica />} />
          <Route path="/trip-types/africa-safari" element={<AfricaSafari />} />
          <Route path="/trip-types/business-travel" element={<BusinessTravel />} />
          <Route path="/trip-types/family-travel" element={<FamilyTravel />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/about" element={<About />} />
          <Route path="/travel-essentials" element={<TravelEssentials />} />
          <Route path="/by-city" element={<ByCity />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          {/* Article Routes */}
          <Route path="/resources/travel-vaccines-canada-guide" element={<TravelVaccinesCanadaGuide />} />
          <Route path="/resources/vaccines-needed-india-travel" element={<VaccinesNeededIndiaTravel />} />
          <Route path="/resources/yellow-fever-vaccine-requirements" element={<YellowFeverVaccineRequirements />} />
          {/* Admin Portal */}
          <Route path="/admin" element={<Admin />} />
          {/* Partner Pages */}
          <Route path="/p/:slug" element={<PartnerLanding />} />
          <Route path="/partner-dashboard/:slug" element={<PartnerDashboard />} />
          {/* Placeholder routes for other Phase 2 pages */}
          <Route path="*" element={<Home />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;